import React, { PropTypes, Component } from 'react';
import cx from 'classnames';
import { withT, wrap } from '../../../../lib/wrappers';

class Filters extends Component {

  setFilters(category, value) {
    const { filter } = this.props;
    filter({ [category]: value });
  }

  get t() {
    return this.props.t;
  }

  render() {
    return (
      <div className={cx('action__filters', { hidden: !this.props.visible })}>
        <div>
          <h5>{this.t('Category')}</h5>
          <div className="action__filters__choices">
            <label>
              <input
                id="action_filters__category--none"
                onChange={() => this.setFilters('category', undefined)}
                checked={!this.props.filters.category}
                name="category"
                value=""
                type="radio"
              />&nbsp;
              {this.t('All')}
            </label>
            <label>
              <input
                id="action_filters__category--transportation"
                onChange={() => this.setFilters('category', 'transportation')}
                checked={this.props.filters.category === 'transportation'}
                type="radio"
                name="category"
                value="transportation"
              />&nbsp;
              {this.t('Transportation')}
            </label>
            <label>
              <input
                id="action_filters__category--housing"
                onChange={() => this.setFilters('category', 'housing')}
                checked={this.props.filters.category === 'housing'}
                type="radio"
                name="category"
                value="housing"
              />&nbsp;
              {this.t('Housing')}
            </label>
            <label>
              <input
                id="action_filters__category--food"
                onChange={() => this.setFilters('category', 'food')}
                checked={this.props.filters.category === 'food'}
                type="radio"
                name="category"
                value="food"
              />&nbsp;
              {this.t('Food')}
            </label>
          </div>
        </div>
        <div>
          <h5>{this.t('Status')}</h5>
          <div className="action__filters__choices">
            <label>
              <input
                id="action_filters__status--none"
                onChange={() => this.setFilters('status', undefined)}
                checked={!this.props.filters.status}
                type="radio"
              />&nbsp;
              {this.t('All')}
            </label>
            <label>
              <input
                id="action_filters__status--pledged"
                onChange={() => this.setFilters('status', 'pledged')}
                checked={this.props.filters.status === 'pledged'}
                type="radio"
              />&nbsp;
              {this.t('Pledged')}
            </label>
            <label>
              <input
                id="action_filters__status--not_pledged"
                onChange={() => this.setFilters('status', 'not_pledged')}
                checked={this.props.filters.status === 'not_pledged'}
                type="radio"
              />&nbsp;
              {this.t('Not Pledged')}
            </label>
            <label>
              <input
                id="action_filters__status--completed"
                onChange={() => this.setFilters('status', 'completed')}
                checked={this.props.filters.status === 'completed'}
                type="radio"
              />&nbsp;
              {this.t('Completed')}
            </label>
          </div>
        </div>
      </div>
    );
  }

}

Filters.propTypes = {
  filter: PropTypes.func.isRequired,
  filters: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
  visible: PropTypes.bool.isRequired,
};

export default wrap(
  withT('takeAction'),
  Filters,
);
